import { persisted } from 'svelte-persisted-store';
import { get } from 'svelte/store';

export function createSearchTableStore(tableName: string, defaultColumnOrderBy: string, defaultPageSize: number = 10): TableStore {
  const initialSetup: SearchTableStoreData = {
    sort: {
      direction: 'desc',
      orderBy: defaultColumnOrderBy,
    },
    pageSize: defaultPageSize,
    filters: {
      search: '',
      kvp: [],
    },
  };

  const tableStore = persisted(tableName, initialSetup);

  return {
    // Expose the underlying store for subscription
    subscribe: tableStore.subscribe,
    get() {
      return get(tableStore);
    },
    getFilterValue(key: string) {
      return get(tableStore).filters.kvp?.find((filter) => filter.key === key)?.value;
    },
    updateSort(direction: 'desc' | 'asc', orderBy: string) {
      tableStore.update((x) => {
        x.sort.direction = direction;
        x.sort.orderBy = orderBy;
        return x;
      });
    },
    updatePageSize(pageSize: number) {
      tableStore.update((x) => {
        x.pageSize = pageSize;
        return x;
      });
    },
    updateSearch(value: string) {
      tableStore.update((x) => {
        x.filters.search = '';
        x.filters.search = value;
        return x;
      });
    },
    resetFilters() {
      tableStore.update((x) => {
        x.filters.kvp = [];
        return x;
      });
    },
    updateFilters(value: string | number | undefined, key: string) {
      tableStore.update((x) => {
        if (x.filters.kvp === undefined) {
          x.filters.kvp = [];
        }

        const existingFilter = x.filters.kvp.find((filter) => filter.key === key);
        if (existingFilter) {
          existingFilter.value = value;
        } else {
          x.filters.kvp.push({ key, value });
        }
        return x;
      });
    },
  };
}

interface SearchTableStoreData {
  sort: {
    direction: 'desc' | 'asc';
    orderBy: string;
  };
  pageSize: number;
  filters: {
    search: string;
    kvp: {
      key: string;
      value: any;
    }[];
  };
}

interface TableStore {
  subscribe: (run: (value: SearchTableStoreData) => void) => () => void;
  get(): SearchTableStoreData;

  getFilterValue(key: string): string | string[] | boolean | number | undefined;

  updateSort(direction: 'desc' | 'asc', orderBy: string): void;

  updatePageSize(pageSize: number): void;
  updateSearch(value: string): void;
  resetFilters(): void;
  updateFilters(value: string | string[] | boolean | number | undefined, key: string): void;
}
